module.exports = __webpack_public_path__ + "static/media/vegplants.1736da03.jpg";